import { selector } from '@/lib/selectors';

const currencies = (state) => state.currencies;
export const currenciesListSelector = selector(currencies, (c) => c);

const timezones = (state) => state.timezones;
export const timezonesListSelector = selector(timezones, (c) => c);
